<template>
  <form-group>
    <v-row>
      <v-col cols="4">
        <input-text
          id="input:cep"
          v-model="payload.cep"
          v-mask="'##.###-###'"
          label="CEP"
          :rules="[requiredRule]"
          :loading="isLoading"
          required
          disabled
          @blur="emitUpdate('cep')"
        />
      </v-col>
      <v-col cols="7">
        <!-- <v-btn
          color="primary"
          :loading="isLoading"
          @click="searchAddress()"
        >
          <v-icon>mdi-magnify</v-icon>
          Buscar
        </v-btn> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5">
        <input-text
          id="input:logradouro"
          v-model="payload.logradouro"
          :rules="[requiredRule]"
          label="Logradouro"
          list="logradouroDataList"
          :loading="isLoading"
          required
          disabled
          @blur="emitUpdate('logradouro')"
        />
        <data-list
          v-if="disabledDatList('logradouro')"
          id="logradouroDataList"
          :list="getInAddressList('logradouro')"
        />
      </v-col>
      <v-col cols="3">
        <input-text
          id="input:tipoLogradouro"
          v-model="payload.tipoLogradouro"
          :rules="[requiredRule]"
          label="Tipo de logradouro"
          :loading="isLoading"
          required
          disabled
          @blur="emitUpdate('tipoLogradouro')"
        />
      </v-col>
      <v-col cols="4">
        <input-text
          id="input:bairro"
          ref="bairro"
          v-model="payload.bairro"
          label="Bairro"
          :rules="[requiredRule]"
          :loading="isLoading"
          list="bairroDataList"
          required
          disabled
          @blur="emitUpdate('bairro')"
        />
        <data-list
          v-if="disabledDatList('bairro')"
          id="bairroDataList"
          :list="getInAddressList('bairro')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <input-text
          id="input:localidade"
          v-model="payload.localidade"
          label="Município"
          :rules="[requiredRule]"
          :loading="isLoading"
          required
          disabled
          @blur="emitUpdate('localidade')"
        />
      </v-col>
      <v-col cols="6">
        <input-state
          id="input:uf"
          v-model="payload.uf"
          label="Estado"
          :rules="[requiredRule]"
          :loading="isLoading"
          required
          disabled
          @blur="emitUpdate('uf')"
        />
      </v-col>
    </v-row>
    <slot />
    <v-row>
      <slot
        name="save"
        :on="on"
      />
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';
import AddressMixin from 'Arch/mixins/AddressMixin';
import DataList from 'Arch/components/list/DataList.vue';

const addressObj = {
  logradouro: '',
  bairro: '',
  localidade: '',
  uf: '',
  cep: '',
  id: '',
  tipoLogradouro: '',
};

export default {
  name: 'AddressInputsScope',
  components: { FormGroup, DataList },
  mixins: [RulesMixin, AddressMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    referenceValue: {
      type: Object,
      default() {
        return {
          ...addressObj,
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    payload: {
      ...addressObj,
    },
    referencePayload: {},
  }),
  computed: {
    isLoading() {
      return this.loading || this.addressLoading;
    },
    saveLoading() {
      return this.isLoading || this.saveAddressLoading;
    },
    getPostalCode() {
      return this.payload.cep.replace(
        /[^0-9]/g,
        '',
      );
    },
    getValue() {
      return this.value || {};
    },
    getReference() {
      return this.referenceValue || {};
    },
    getReferenceProp() {
      const obj = this.referencePayload;
      return (key) => Object.keys(
        obj,
      ).filter(
        (k) => obj[k] === key,
      )[0];
    },
    emitUpdate() {
      return (key) => {
        this.value[
          this.getReferenceProp(
            key,
          )
        ] = this.payload[key];
      };
    },
    on() {
      return {
        save: this.saveAddress,
        loading: this.saveLoading,
      };
    },
  },
  watch: {
    getValue: {
      immediate: true,
      deep: true,
      handler(obj) {
        if (this.hasObjContentProp(obj)) {
          this.$nextTick(
            () => {
              this.setPayloadContentValue(obj);
            },
          );
        }
      },
    },
    getReference: {
      immediate: true,
      deep: true,
      handler(obj) {
        if (this.hasObj(obj)) {
          this.mountReferencePayload(obj);
        }
      },
    },
    saveLoading: {
      immediate: true,
      handler(bool) {
        if (typeof bool === 'boolean') {
          this.$emit('address-loading', bool);
        }
      },
    },
  },
  methods: {
    handleAddressPayload(arr = []) {
      const [item] = arr;
      if (arr.length === 1) {
        this.payload = item;
        this.updateValue();
        return;
      }
      if (arr.length > 1) {
        const { cep } = { ...this.payload };
        const [{ localidade, uf, tipo_logradouro: tipoLogradouro }] = arr;
        this.payload = {
          ...addressObj,
        };
        this.payload.cep = cep;
        this.payload.localidade = localidade;
        this.payload.uf = uf;
        this.payload.tipoLogradouro = tipoLogradouro;
        this.updateValue();
      }
    },
    updateValue() {
      this.$nextTick(
        () => {
          Object.keys(
            this.payload,
          ).forEach(
            (key) => {
              this.emitUpdate(key);
            },
          );
        },
      );
    },
    mountReferencePayload(obj) {
      this.referencePayload = Object.keys(obj)
        .map(
          (key) => ({
            [obj[key]]: key,
          }),
        ).reduce(
          ...this.transformToObj(),
        );
    },
    setPayloadContentValue(obj) {
      const reference = this.referencePayload;
      this.payload = Object.keys(
        reference,
      ).map(
        (key) => ({
          [reference[key]]: obj[key],
        }),
      ).reduce(
        ...this.transformToObj(),
      );
    },
    proxyPayloadToReference(obj) {
      return Object.keys(obj)
        .map(
          (key) => ({
            [this.getReference[key]]: obj[key],
          }),
        ).reduce(
          ...this.transformToObj(),
        );
    },
    transformToObj() {
      return [
        (obj, item) => ({ ...obj, ...item }),
        {},
      ];
    },
    hasObj(obj) {
      return Object.keys(obj).length >= 1;
    },
    hasObjContentProp(obj = {}) {
      if (!this.hasObj(obj)) {
        return false;
      }
      return Object.keys(obj)
        .map(
          (key) => obj[key],
        ).filter(
          (item) => item !== '',
        ).length >= 1;
    },
  },
};
</script>
